import { UiToast, UiLoader } from "libs/raas-ui-react-components/src/components";
import { createContext, useState } from "react";
import interceptor from "services/api/interceptor.service";
import loader from "services/util/loader.service";

const UtilContext = createContext({
    showToast: ((item:boolean)=>{}),
    setShowLoader: ((item:boolean)=>{}),
    setTextLoader: ((item:string)=>{}),
    setSMessageE: ((item:string)=>{}),
    setTitle: ((item:string)=>{}),
    setTypeError: ((item:string)=>{}),
})

/**
 * @description global aplication context
 */
export function UtilProvider ({children}:any){

    // TOAST STATES
    const [ showError, showToast ] = useState(false);
    const [ msgError, setSMessageE ] = useState("");
    const [ titleError, setTitle ] = useState("");
    const [ typeError, setTypeError ] = useState("");
    
    // LOADER STATES
    const [ showLoader, setShowLoader ] = useState(false);
    const [ textLoader, setTextLoader ] = useState("Llamando al servicio...");

    
    const handleToastClick = ()=>{
        showToast(false);
    }
    
    // INITIALICE INTERCEPTOR
    interceptor();
    loader(setShowLoader);
    return (
        <UtilContext.Provider value={{showToast, setSMessageE, setTitle, setTypeError, setShowLoader, setTextLoader}}>
            <UiLoader visible={showLoader} text={textLoader} newLoader={true}></UiLoader>
            <UiToast onHandleClickToast={handleToastClick} textTitle={titleError} textDesc={msgError} type={typeError} visible={showError}></UiToast>
            {children}
        </UtilContext.Provider>
    ) 
    
}

export default UtilContext;